import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQS } from "../data/content";
import { fadeUp, viewportOnce, EYEBROW } from "../lib/motion";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-graytone-light py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="text-center"
        >
          <span className={EYEBROW}>FAQ</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-navy leading-[1.05] font-bold">
            Pertanyaan yang <span className="italic text-gold-dark">Sering Diajukan</span>
          </h2>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-graytone-medium/60 bg-white px-6 shadow-soft data-[state=open]:border-gold/50 transition-colors"
              >
                <AccordionTrigger className="text-left font-serif text-lg md:text-xl font-semibold text-navy hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-graytone-dark text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
